
export const DIALOG_CONFIRMATION_TICKET_TITLE = "Вы действительно хотите удалить тикет?"

export const DIALOG_CONFIRMATION_TICKET_CONTENT = "Обратите внимание, данное действие необратимо и восстановить тикет Вы не сможете."

export const DIALOG_CONFIRMATION_TICKET_OK_BUTTON = "Удалить"

export const DIALOG_CONFIRMATION_TICKET_TITLE_FAST_ANSWER = "Быстрый ответ"

export const DIALOG_CONFIRMATION_TICKET_CONTENT_FAST_ANSWER = "Сообщение"

export const DIALOG_CONFIRMATION_TICKET_OK_BUTTON_FAST_ANSWER = "Ответить"

export const DIALOG_CONFIRMATION_TICKET_CANCEL_BUTTON = "Отмена"
